module.exports = __webpack_public_path__ + "img/dashboardIcon3.3985c47e.png";